export default {
  default: () => import("/opt/atlassian/pipelines/agent/build/frontend/layouts/default.vue").then(m => m.default || m),
  home: () => import("/opt/atlassian/pipelines/agent/build/frontend/layouts/home.vue").then(m => m.default || m)
}